import moment from 'moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { FlexGap, Spinner, tokens } from '@treams/treams-ui';

import { CycleMomentOptionCard } from './CycleMomentOptionCard';

export default function CycleMomentSelector(props: {
	type: graphql.MomentType;
	onSelect: (moment?: { id: string }, automatic?: boolean) => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const query = graphql.useCycleMomentSelectorQuery({});

	const moments = query.data?.viewer.moments.filter(
		(moment) =>
			moment.momentTemplate.type === props.type && moment.status === graphql.MomentStatus.Open,
	);

	useEffect(() => {
		if (moments && moments.length === 0) {
			props.onSelect(undefined, true);
		}
	}, [moments?.length]);

	if (!moments) {
		return <Spinner centered />;
	}

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.list}>
			{moments.map((item) => (
				<CycleMomentOptionCard
					key={item.id}
					title={localize(item.momentTemplate.title).text}
					description={t('cycle.momentSelector.moment.description', {
						endDate: moment.utc(item.endDate).format('LL'),
					})}
					onClick={() => props.onSelect(item)}
				/>
			))}
		</FlexGap>
	);
}
